"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _linkModule = _interopRequireDefault(require("./link.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Link(props) {
  var data = props.data,
    row = props.row,
    onRowAction = props.onRowAction,
    childOnRowAction = props.childOnRowAction,
    applyLinkstyles = props.applyLinkstyles,
    column = props.column;
  var datatoDisplay = row;
  var name = column.name;
  if (column !== null && column !== void 0 && column.isArray) {
    for (var item in name) {
      if (datatoDisplay[name[item]]) {
        datatoDisplay = datatoDisplay[name[item]];
      }
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      onRowAction && onRowAction(row);
      childOnRowAction && childOnRowAction(row);
    },
    className: "".concat(applyLinkstyles ? _linkModule["default"].linkStyles : _linkModule["default"].wrapper)
  }, column !== null && column !== void 0 && column.isArray ? datatoDisplay : data);
}
var _default = Link;
exports["default"] = _default;